import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { FAQS } from "../../data/programs";

export const FAQSection = () => {
  return (
    <section id="faq" data-testid="faq-section" className="py-20 md:py-28">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs uppercase tracking-[0.2em] text-aiou-gold font-semibold">
            Frequently asked
          </span>
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl text-aiou-ink leading-[1.1] tracking-tight">
            Everything overseas students usually ask before applying.
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-2xl border border-aiou-sand bg-white px-5 sm:px-6 data-[state=open]:border-aiou-gold/50 data-[state=open]:shadow-[0_8px_24px_rgba(36,66,101,0.06)] transition-all"
            >
              <AccordionTrigger className="text-left font-serif text-lg sm:text-xl text-aiou-ink hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-aiou-slate text-[15px] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
